export default "__VITE_ASSET__CbxzU9X9__"